import { useRef, useState } from "react"
import classNames from "classnames"
import ArrowIcon from "/static/images/landing/icons/arrow.svg"
import SlickSlider from "react-slick"

import "slick-carousel/slick/slick.css"
import "./Slider.scss"

const Slider = ({ content, children, settings }) => {
  const sliderRef = useRef(null)
  const [sliderPart, setSliderPart] = useState("start")

  const onNext = () => {
    sliderRef.current.slickNext()
  }
  const onPrev = () => {
    sliderRef.current.slickPrev()
  }

  const DEAFULT_SETTING = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
      },
      {
        breakpoint: 10000,
        settings: "unslick",
      },
    ],
    beforeChange: (_, index) => {
      const roundedIndex = Math.ceil(index)
      if (roundedIndex == 0) {
        setSliderPart("start")

        return
      }

      if (
        roundedIndex ==
        content.length - Math.floor(sliderSettings.slidesToShow)
      ) {
        setSliderPart("end")

        return
      }

      setSliderPart("middle")
    },
    appendDots: (dots) => {
      return (
        <ul>
          <button
            className="landing-slider__controller --prev"
            disabled={sliderPart === "start"}
            onClick={onPrev}
          >
            <ArrowIcon />
          </button>
          <div
            className={classNames("landing-slider__dots-wrapper", {
              "landing-slider__dots-wrapper--last": sliderPart === "end",
            })}
          >
            {dots}
          </div>
          <button
            className="landing-slider__controller --next"
            disabled={sliderPart === "end"}
            onClick={onNext}
          >
            <ArrowIcon />
          </button>
        </ul>
      )
    },
  }

  const sliderSettings = {
    ...DEAFULT_SETTING,
    ...settings,
  }

  return (
    <SlickSlider
      ref={(slider) => {
        sliderRef.current = slider
      }}
      {...sliderSettings}
      className="landing-slider"
    >
      {children}
    </SlickSlider>
  )
}

export default Slider
